import React, { useReducer, useEffect, useContext } from "react";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";

import Details from "./partials/details/Details";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import useConfirm from "../../../HOC/custom/useConfirm";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";

import GalleryPictures from "../../UI/shared/gallery/GalleryPictures";
import RecentComments from "../../UI/shared/recentComments/RecentComments";
import RecentLikes from "../../UI/shared/recentLikes/RecentLikes";
import { detailsReducer,detailsInitialState } from "../../../reducers/module/detailsReducer";
import { confirmAndDisabledGeneral, confirmAndEnabledGeneral, loadItemGeneral, loadItemsGeneral } from "../../../helpers/ModuleHelperFunctions";


const ProductView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [detailsState, detailsDispatch] = useReducer(detailsReducer,detailsInitialState);
  const navigate = useNavigate();
  let { id } = useParams();
  const { confirm } = useConfirm();
  
  const loadItem = async () => {
    await loadItemGeneral(id,`${moduleConfig.url}/${id}`,detailsDispatch)
  };

  const confirmAndDisabled = async (id) => {
    let res = await confirmAndDisabledGeneral(id,`${moduleConfig.url}/change-status`,confirm,detailsDispatch)
    //console.log(res)
    if(res){
      await loadItemGeneral(id,`${moduleConfig.url}/${id}`,detailsDispatch)
    }
  }; 

  const confirmAndEnabled = async (id) => {
    let res = await confirmAndEnabledGeneral(id,`${moduleConfig.url}/change-status`,confirm,detailsDispatch)
    //console.log(res)
    if(res){
      await loadItemGeneral(id,`${moduleConfig.url}/${id}`,detailsDispatch)
    }
  };

  useEffect(() => {
    loadItem();
    setBreadcrumb([moduleConfig.breadcrumbs.listing, moduleConfig.breadcrumbs.details]);
  }, [id]);







  return (
    <DashboardLayout>
      {detailsState.isFetching ? (
        <ContainerLoading />
      ) : (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.item && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl="fossils"
                  ></ModuleHeader>

                  <div className="border mb-1 p-1 bg-light text-white rounded">
                    <Link
                      title={`Update Basic Fossil Details`}
                      to={`/${moduleConfig.url}/update/${detailsState.data.item._id}`}
                      className="btn btn-custom-2  border me-1"
                    >
                      <i className="fas fa-pencil-alt text-white me-1"></i>{" "}
                      <span className="text-white">Update</span>
                    </Link>

                    {(detailsState.data.item.status === "1" ||
                      detailsState.data.item.status === 1) && (
                        <Button
                          className="btn-custom-2 me-1"
                          variant="primary"
                          title={`Disable ${moduleConfig.singleItemTitle}`}
                          onClick={() =>
                            confirmAndDisabled(detailsState.data.item._id)
                          }
                        >
                          <i className="fa fa-archive me-1" aria-hidden="true"></i>

                          <span className="text-white">Disable</span>
                        </Button>
                      )}

                    {(detailsState.data.item.status === "0" ||
                      detailsState.data.item.status === 0) && (
                        <Button
                          className="btn-custom-2 me-1"
                          variant="primary"
                          title={`Enable ${moduleConfig.singleItemTitle}`}
                          onClick={() =>
                            confirmAndEnabled(detailsState.data.item._id)
                          }
                        >
                          <i className="fa fa-arrow-up"> </i>{" "}
                          <span className="text-white">Enable</span>
                        </Button>
                      )}
                    
                    
                    
                     
                    


                    

                  </div>

                  <Details
                    item={detailsState.data.item}
                    detailsDispatch={detailsDispatch}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default ProductView;
